// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    const scrollcontent = accordion.getAttribute("js-acc-single-trigger-scroll") || null;
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });   
}
// accordions js end

(function() {
  
      faq_taggol();  
  
  const header_operlay = document.querySelector("[data-banner-header-overlay]");
  if(header_operlay){
    document.body.classList.add('header-overlay');
  } 
  

})();

//faq section
const faq_main_wap = document.querySelector('[faq_main_wap]') || null;
if (faq_main_wap) {
  const faq_toggles = faq_main_wap.querySelectorAll('[data-act-title]') || null;
  const faq_content_wap = faq_main_wap.querySelector('[faq_content_wap]') || null;
  const faq_content_tabs = faq_content_wap.querySelectorAll('.tabs') || null;
  const faq_dropdown = faq_main_wap.querySelector('.faq-category-dropdown') || null;
  const faq_selected = faq_main_wap.querySelector('.faq-category-selected') || null;
  const mian_tag = document.querySelector('.faq-category')|| null;
  const content = document.querySelector("[js-acc-single-content]");
  
  if (faq_content_wap) {
    faq_toggles.forEach((faq) => {
      faq.addEventListener('click', (event) => {
        faq_content_tabs.forEach((tab) => {
          tab.classList.remove('active');
          tab.style.display = 'none';
        });

        faq_toggles.forEach((toggle) => {
          toggle.classList.remove('active-tab');
        });

        const targetSelector = event.currentTarget.getAttribute('data-act-title');
        const targetTab = faq_content_wap.querySelector(targetSelector);

        if (targetTab) {
          targetTab.classList.add('active');
          targetTab.style.display = 'block';
          
         
        }
        event.currentTarget.classList.add('active-tab');
        

        if (faq_dropdown && faq_selected) {
          faq_selected.textContent = event.currentTarget.textContent.trim();
          faq_dropdown.classList.remove('open'); // Adjust class based on your dropdown open state
          mian_tag.classList.remove('active');
          if(content){
            content.style.maxHeight = null;
          }
        }
      });
    });

    if (faq_dropdown) {
      faq_dropdown.addEventListener('click', () => {
        faq_dropdown.classList.toggle('open'); // Add/remove "open" class for the dropdown
      });
    }
  }
}
//faq section end

//autosize section end
// autosize();
function autosize() {
    const textareas = document.querySelectorAll('.autosize');

    textareas.forEach(textarea => {
        textarea.setAttribute('rows', 1);
        resize(textarea);

        textarea.addEventListener('input', function() {
            resize(textarea);
        });
    });

    function resize(textarea) {
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';
    }
}

// Initialize autosize on page load
document.addEventListener("DOMContentLoaded", autosize);

//autosize section end

// sart custom code

class DrawerClose extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    this.closest('details').querySelector('summary').click();
  }
}

 // <drawer-close>
 //   <a href="javascript:void(0);"class="close-icon" id="mobile_menu_click">text</a>
 // </drawer-close>

customElements.define('drawer-close', DrawerClose);




//==================product material popup (dev)============

const materialItems = document.querySelectorAll('.material-item');

// Check karo ke koi item mila ke nahi
if (materialItems.length > 0) {
  materialItems.forEach(item => {
    item.addEventListener('click', () => {
      const title = item.getAttribute('data-title');

      // Remove active from all popups
      const popups = document.querySelectorAll('.material-popup');
      popups.forEach(popup => {
        popup.style.display = 'none';     
        document.querySelector('body').classList.remove('overflow-hidden');
      });

      // Find and activate the matching popup
      const matchedPopup = document.querySelector(`.material-popup[data-content="${title}"]`);
      if (matchedPopup) {
        matchedPopup.style.display = 'block';   
        document.querySelector('body').classList.add('overflow-hidden');  

      }
    });
  });
}


// Select all close buttons
const closeButtons = document.querySelectorAll('.close-material-popup');

if (closeButtons.length > 0) {
  closeButtons.forEach(button => {
    button.addEventListener('click', function() { // use normal function here
      const popup = this.closest('.material-popup'); // 'this' now correctly refers to the clicked button
      if (popup) {
        popup.style.display = 'none'; // hide the popup
        document.body.classList.remove('overflow-hidden'); // remove class from body
      }
    });
  });
}


document.body.addEventListener('click', function(event) {
  const target = event.target;

  if (target.classList.contains('material-popup-wrapper') || target.classList.contains('ring-size-popup-wrapper') ||  target.classList.contains('nackless-size-popup-wrapper')) {
    const popups = document.querySelectorAll('.material-popup');
       const popup_sizes = document.querySelector('.ring-size-popup');
        const popup_necks = document.querySelector('.nackless-size-popup');
        if(popup_necks){
         popup_necks.style.display = 'none';
         document.body.classList.remove('overflow-hidden');
       }
       if(popup_sizes){
         popup_sizes.style.display = 'none';
         document.body.classList.remove('overflow-hidden');
       }
      popups.forEach(popup => {
        if (getComputedStyle(popup).display !== 'none') {
          popup.style.display = 'none';
          document.body.classList.remove('overflow-hidden');
        }
      });
  }
});





// Select all size_text elements
document.addEventListener('click', function(e) {
  // Check if the clicked element has class 'size_text'
  if (e.target.classList.contains('size_text')) {
    const popup = document.querySelector('.ring-size-popup');
    const nacklesspopup = document.querySelector('.nackless-size-popup');

    // Show relevant popups
    if (popup) {
      popup.style.display = 'block';
      document.body.classList.add('overflow-hidden');
    }

    if (nacklesspopup) {
      nacklesspopup.style.display = 'block';
      document.body.classList.add('overflow-hidden');
    }
  }
});



//  close buttons ring-size-popup
// Select all close buttons for ring-size and neckless popups
const closeButtons_size = document.querySelectorAll('.close-ring-size-popup, .close-nackless-size-popup');

if (closeButtons_size.length > 0) {
  closeButtons_size.forEach(function(button) {
    button.addEventListener('click', function() {
      const popup_size = document.querySelector('.ring-size-popup');
      const popup_neck = document.querySelector('.nackless-size-popup');

      if (popup_neck) {
        popup_neck.style.display = 'none';
      }
      if (popup_size) {
        popup_size.style.display = 'none';
      }

      // Remove overflow-hidden class from body
      document.body.classList.remove('overflow-hidden');
    });
  });
}




// ================Globo Product Options JS (dev) ====================
// function addTextareaMaxlength() {
//   const textareas = document.querySelectorAll('.custom_click textarea');

//   if (textareas.length > 0) {
//     textareas.forEach(textarea => {
//       textarea.setAttribute('maxlength', '7'); 
//     });
//   }
// }

// // 🔁 Keep checking until .custom_click appears (for dynamically loaded elements)
// const checkInterval = setInterval(() => {
//   if (document.querySelector('.custom_click textarea')) {
//     addTextareaMaxlength();
//     clearInterval(checkInterval); // stop checking once found
//   }
// }, 500);

// ================== read more button PDP (dev)
  const readMoreBtn = document.querySelector(".read_more_custom");
  const descShow = document.querySelector(".product__description_show");

  if (readMoreBtn && descShow) {
    readMoreBtn.addEventListener("click", function(event) {
      event.preventDefault(); 
      console.log("Button clicked");

      const descHeight = descShow.scrollHeight; // Full height
      descShow.style.maxHeight = descHeight + "px";
      descShow.classList.add("expanded");
    });
  } 


  const popupTriggers = document.querySelectorAll(".popup_clickevent"); // Note the plural
const popup = document.querySelector(".review-popup");
const popupClose = document.querySelector(".review-popup .close-review-popup");
const body = document.body;

if (popupTriggers.length && popup && popupClose) {
  // 🔹 Open popup for all triggers
  popupTriggers.forEach(trigger => {
    trigger.addEventListener("click", function(e) {
      e.preventDefault();
      console.log(trigger, "popupTrigger");
      popup.style.display = 'block';
      body.classList.add("overflow-hidden");
    });
  });

  // 🔹 Close popup
  popupClose.addEventListener("click", function(e) {
    e.preventDefault();
    popup.style.display = 'none';
    body.classList.remove("overflow-hidden");
  });
}



// ====== quick Neckless size popup close
function initCloseNecklessBtn() {
  const closeNecklessBtn = document.querySelector(".product-quick-view-content .close-nackless-size-popup");

  if (closeNecklessBtn) {
    closeNecklessBtn.addEventListener("click", function () {
      const popupNeck = document.querySelector(".nackless-size-popup");
      if (popupNeck) {
        popupNeck.style.display = "none";
        document.body.classList.remove("overflow-hidden");
      }
       const popupNeck_ring = document.querySelector(".ring-size-popup");
      if (popupNeck_ring) {
        popupNeck_ring.style.display = "none";
        document.body.classList.remove("overflow-hidden");
      }
    });

    console.log("✅ close-nackless-size-popup event attached");
    return true; // stop retrying
  }
  return false;
}

// Keep checking every 300ms until element appears
const checkNecklessInterval = setInterval(() => {
  if (initCloseNecklessBtn()) {
    clearInterval(checkNecklessInterval);
  }
}, 300);

// ====== quick Ring size popup close
function initCloseRingBtn() {
  const closeringBtn = document.querySelector(".product-quick-view-content .close-ring-size-popup");

  if (closeringBtn) {
    closeringBtn.addEventListener("click", function () {
      const popupNeck = document.querySelector(".nackless-size-popup");
      if (popupNeck) {
        popupNeck.style.display = "none";
      }

      const popupRing = document.querySelector(".ring-size-popup");
      if (popupRing) {
        popupRing.style.display = "none";
      }

      // remove overflow-hidden
      document.body.classList.remove("overflow-hidden");
    });

    console.log("✅ close-ring-size-popup event attached");
    return true; // stop retrying
  }

  return false;
}

// Keep checking every 300ms until element appears
const checkRingBtn = setInterval(() => {
  if (initCloseRingBtn()) {
    clearInterval(checkRingBtn);
  }
}, 300);




// Select all dropdown triggers PDP
const dropdowns = document.querySelector(".select_dropdown");
if(dropdowns){

  const ul_select = dropdowns.nextElementSibling;
  
  dropdowns.addEventListener("click", function(e) {
    e.preventDefault();
    ul_select.style.display = (ul_select.style.display === "block") ? "none" : "block";
      this.classList.toggle("active");
  
  });
  
  
  // Optional: close dropdown if clicking outside
  document.addEventListener("click", function(e) {
      const ul_select = dropdowns.nextElementSibling;
      if (!dropdowns.contains(e.target) && !ul_select.contains(e.target)) {
        ul_select.style.display = "none";
        dropdowns.classList.remove("active");
      }
    
  });
}



 //blog Dropdown change
const sortingDropdown = document.getElementById("sorting-dropdown");

if (sortingDropdown) {
  sortingDropdown.addEventListener("change", function () {
    const selectedOption = this.value;

    // blog posts sort karva
    sortBlogPosts(selectedOption);
  });
}

// Sorting function
function sortBlogPosts(option) {
  const postsContainer = document.querySelector(".blog-articles");
  const posts = Array.from(postsContainer.querySelectorAll(".cust_sort_blog"));

  switch (option) {
    case "title-ascending":
      posts.sort((a, b) =>
        a.querySelector(".blog-post-title").textContent.localeCompare(
          b.querySelector(".blog-post-title").textContent
        )
      );
      break;

    case "title-descending":
      posts.sort((a, b) =>
        b.querySelector(".blog-post-title").textContent.localeCompare(
          a.querySelector(".blog-post-title").textContent
        )
      );
      break;

    case "created-ascending":
      posts.sort((a, b) => {
        const dateA = new Date(a.querySelector(".blog-post-date").textContent);
        const dateB = new Date(b.querySelector(".blog-post-date").textContent);
        return dateA - dateB;
      });
      break;

    case "created-descending":
      posts.sort((a, b) => {
        const dateA = new Date(a.querySelector(".blog-post-date").textContent);
        const dateB = new Date(b.querySelector(".blog-post-date").textContent);
        return dateB - dateA;
      });
      break;
    default:
      break;
  }

  // Clear & append sorted
  postsContainer.innerHTML = "";
  posts.forEach((post) => postsContainer.appendChild(post));
}


// qick view variant_dropdown click
document.addEventListener("click", function(e) {
  // Find if the click is inside a .variant_dropdown
  const dropdown = e.target.closest(".product-modal .variant_dropdown");
  
  if (dropdown) {
    const ul_select = dropdown.querySelector(".product-modal ul[custom-dropdown]");
    
    if (ul_select) {
      // Toggle visibility
      ul_select.style.display = (ul_select.style.display === "block") ? "none" : "block";
      dropdown.querySelector(".product-modal .select_dropdown").classList.toggle("active");
    }
  } else {
    // Clicked outside any .variant_dropdown — close all open dropdowns
    const allDropdowns = document.querySelectorAll(".product-modal .variant_dropdown ul[custom-dropdown]");
    allDropdowns.forEach(ul => ul.style.display = "none");

    const allSelects = document.querySelectorAll(".product-modal .variant_dropdown .select_dropdown.active");
    allSelects.forEach(sel => sel.classList.remove("active"));
  }
});


const links = document.querySelectorAll('.short_description p a');
const tooltips = document.querySelectorAll('.tooltip-text');

links.forEach((link, index) => {
  link.addEventListener('mouseenter', () => {
    // Remove "active" class from all tooltips
    tooltips.forEach(tip => tip.classList.remove('active'));

    // Get the matching tooltip
    const tooltip = tooltips[index];
    if (tooltip) {
      tooltip.classList.add('active');

      // Remove tooltip from current position if already appended somewhere else
      tooltip.parentNode?.removeChild(tooltip);

      // Append the tooltip inside the hovered <a> tag
      link.appendChild(tooltip);
    }
  });

  link.addEventListener('mouseleave', () => {
    const tooltip = tooltips[index];
    if (tooltip) {
      tooltip.classList.remove('active');
      // Optionally, move it back to its original container
      const container = document.querySelector('.tooltip-container');
      if (container) container.appendChild(tooltip);
    }
  });
});
